import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import {
  Phone,
  Mail,
  MapPin,
  Clock,
  ArrowRight,
  ShieldCheck, // ✅ ADD
} from "lucide-react";

import logo from "../assets/logo.png";
// Ghana format, no + sign


/* ================= FOOTER ================= */
export default function Footer() {
  const year = new Date().getFullYear();
  const [dark, setDark] = useState(true);

  /* ================= THEME SYNC ================= */
  useEffect(() => {
    const loadTheme = () => {
      const t = localStorage.getItem("theme");
      setDark(t !== "light");
    };

    loadTheme();
    window.addEventListener("theme-change", loadTheme);
    return () => window.removeEventListener("theme-change", loadTheme);
  }, []);

  const theme = {
    footerBg: dark
      ? "bg-gradient-to-b from-gray-950 to-black text-gray-300"
      : "bg-gradient-to-b from-gray-100 to-white text-gray-700",

    title: dark ? "text-white" : "text-gray-900",
    border: dark ? "border-white/10" : "border-gray-200",

    link: dark
      ? "hover:text-white"
      : "hover:text-gray-900",

    icon: dark ? "text-sky-400" : "text-sky-600",

    muted: dark ? "text-gray-400" : "text-gray-500",
  };

  return (
    <footer className={`${theme.footerBg}`}>
      {/* ================= MAIN ================= */}
      <div className="max-w-7xl mx-auto px-6 py-16 grid gap-12 md:grid-cols-4">
        {/* COMPANY */}
        <div>
          <div className="flex items-center gap-3 mb-5">
           <div
  className={`h-11 w-11 flex items-center justify-center rounded transition ${
    dark ? "bg-white p-1" : ""
  }`}
>
  <img
    src={logo}
    alt="Company Logo"
    className="h-full w-full object-contain"
  />
</div>

            <h3 className={`font-bold text-lg ${theme.title}`}>
              Deonyak Hearse Service
            </h3>
          </div>

          <p className={`text-sm leading-relaxed ${theme.muted}`}>
            Providing dignified, reliable and professional hearse services.
            Every journey is handled with respect, care and excellence.
          </p>

          <div className="mt-5 flex items-center gap-2 text-sm">
            <ShieldCheck className={theme.icon} size={16} />
            <span className={theme.muted}>
              Trusted & Licensed Service Provider
            </span>
          </div>
        </div>

        {/* QUICK LINKS */}
        <div>
          <h4 className={`font-semibold mb-4 ${theme.title}`}>
            Quick Links
          </h4>

          <ul className="space-y-3 text-sm">
            <FooterLink to="/" label="Home" theme={theme} />
            <FooterLink to="/book" label="Book Hearse" theme={theme} />
            <FooterLink to="/gallery" label="Gallery" theme={theme} />
            <FooterLink to="/contact" label="Contact" theme={theme} />
          </ul>
        </div>

        {/* CONTACT */}
        <div>
          <h4 className={`font-semibold mb-4 ${theme.title}`}>
            Contact Information
          </h4>

          <ul className="space-y-4 text-sm">
            <li className="flex items-center gap-3">
              <Phone size={16} className={theme.icon} />
              <span>+233 24 522 6992</span>
            </li>

            <li className="flex items-center gap-3">
              <Mail size={16} className={theme.icon} />
              <span>info@deonyakhearse.com</span>
            </li>

            <li className="flex items-center gap-3">
              <MapPin size={16} className={theme.icon} />
              <span>Western Region, Bakaekyir</span>
            </li>
          </ul>
        </div>

        {/* HOURS */}
        <div>
          <h4 className={`font-semibold mb-4 ${theme.title}`}>
            Service Hours
          </h4>

          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-3">
              <Clock size={16} className={theme.icon} />
              <span>24 Hours Service</span>
            </li>

            <li className={theme.muted}>
              Monday – Sunday
            </li>

            <li className={`text-xs ${theme.muted}`}>
              Emergency & Scheduled Services Available
            </li>
          </ul>
        </div>
      </div>

      {/* ================= BOTTOM ================= */}
      <div
        className={`border-t ${theme.border} py-5 text-center text-sm ${theme.muted}`}
      >
        © {year} Deonyak Hearse Service. All Rights Reserved.
      </div>
    </footer>
  );
}

/* ================= LINK COMPONENT ================= */
function FooterLink({ to, label, theme }) {
  return (
    <li>
      <NavLink
        to={to}
        className={`flex items-center gap-2 transition ${theme.link}`}
      >
        <ArrowRight size={14} className={theme.icon} />
        {label}
      </NavLink>
    </li>
  );
}
